import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import RacePresentational from '../components/Races';
import * as  commonActions from '../actions/common';
import * as  raceActions from '../actions/races';
import * as  liveActions from '../actions/liveActions';

class Race extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updatePage: "",
      raceList: [],
    };
    this.ExecuteUpdate = this.ExecuteUpdate.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    this.props.raceActions.getRaces()
      .then(() => {

        var tempRaceList = this.generateLinks(this.checkPDF(this.reviewList(this.props.race.raceList)));
        // this.setState({
        //   raceList: this.generateLinks(this.checkPDF(this.reviewList(this.props.race.raceList))),
        // });

        this.props.liveActions.getLive()
          .then(() => {
            this.setState({
              EventLive: this.props.live.live
            });

            var tempLive = this.props.live.live;

            var list1 = tempRaceList.map((item, i) => {
              if (item.Type === tempLive.Type && item.racecode === tempLive.raceCode) {
                const item2 = {
                  ...item,
                  isLive: true,
                };
                return item2;
              }
              const item3 = {
                ...item,
                isLive: false,
              };
              return item3;
            });

            this.setState({
              raceList: list1,
            });

          });

      });
  }

  ExecuteUpdate() {
    this.getData();
  }

  reviewList(list) {
    var temp = list.map((item, i) => {
      if (item.Type === 105 || item.Type === 100) {
        var existFinal = item.EventName.toLowerCase().indexOf("final");
        if (existFinal !== -1) {
          const item2 = {
            ...item,
            fase: 2,
            StartListFileName: item.FinalsStartListFileName,
            ResultsFileName: item.FinalsResultsFileName,
          };
          return item2;
        } else {
          var existRound1 = item.EventName.toLowerCase().indexOf("round");
          if (existRound1 !== -1) {
            const item2 = {
              ...item,
              fase: 1,
            };
            return item2;
          } else {
            const item2 = {
              ...item,
              fase: 0,
            };
            return item2;
          }
        }
      }

      return item;
    });

    // return temp.sort(function (a, b) {
    //   var af = a.Sortorder;
    //   var bf = b.Sortorder;
    //   var as = a.EventName;
    //   var bs = b.EventName;

    //   if (af === bf) {
    //     return (as < bs) ? -1 : (as > bs) ? 1 : 0;
    //   } else {
    //     return (af < bf) ? -1 : 1;
    //   }
    // });

    return temp;
    // return list.sort((a, b) => (a.Sortorder > b.Sortorder) ? 1 : -1)

  }

  checkPDF(races) {
    var list1 = races.map((item, i) => {
      if (item.StartListFileName !== null && item.StartListFileName !== "") {
        const item2 = {
          ...item,
          fileExistsStartList: this.doesFileExist(process.env.PUBLIC_URL + '/PDF/' + item.StartListFileName + ".pdf"),
          fileStartListPath: process.env.PUBLIC_URL + '/PDF/' + item.StartListFileName + ".pdf",
        };
        return item2;
      }
      const item3 = {
        ...item,
        fileExistsStartList: false,
      };
      return item3;
    });

    var list2 = list1.map((item, i) => {
      if (item.ResultsFileName !== null && item.ResultsFileName !== "") {
        const item2 = {
          ...item,
          fileExistsResults: this.doesFileExist(process.env.PUBLIC_URL + '/PDF/' + item.ResultsFileName + ".pdf"),
          fileResultstPath: process.env.PUBLIC_URL + '/PDF/' + item.ResultsFileName + ".pdf",
        };
        return item2;
      }
      const item3 = {
        ...item,
        fileExistsStartList: false,
      };
      return item3;
    });



    return list2;
  }

  doesFileExist(urlToFile) {
    var xhr = new XMLHttpRequest();
    xhr.open('HEAD', urlToFile, false);
    xhr.send();

    if (xhr.status === "404" || xhr.status === 404) {
      return false;
    } else {
      return true;
    }
  }

  generateLinks(list) {
    var list2 = list.map((item, i) => {
      if (item.Type === 7 || item.Type === 8 || item.Type === 9) {
        return {
          ...item,
          startListLink: `/PointsRace/startlist/${item.racecode}`,
          resultsLink: `/PointsRace/results/${item.racecode}`,
        };
      } else if (item.Type === 4 || item.Type === 5) {
        return {
          ...item,
          startListLink: `/Scratch/startlist/${item.racecode}`,
          resultsLink: `/Scratch/results/${item.racecode}`,
        };
      } else if (item.Type === 6) {
        return {
          ...item,
          startListLink: `/Keirin/startlist/${item.racecode}`,
          resultsLink: `/Keirin/results/${item.racecode}`,
        };
      } else if (item.Type === 11) {
        return {
          ...item,
          startListLink: `/SprintTournament/startlist/${item.racecode}`,
          resultsLink: `/SprintTournament/results/${item.racecode}`,
        };
      } else if (item.Type === 105 || item.Type === 100) {

        if (item.fase == "1") {

          return {
            ...item,
            startListLink: `/TT/startlist/${item.racecode}/${item.fase}`,
            resultsLink: `/TT/Round1/${item.racecode}/${item.fase}`,
          };
        } else {

          return {
            ...item,
            startListLink: `/TT/startlist/${item.racecode}/${item.fase}`,
            resultsLink: `/TT/results/${item.racecode}/${item.fase}`,
          };
        }

      }
      return item;
    });

    return list2;
  }




  // componentWillReceiveProps(nextProps) {
  //     debugger;
  //     if (this.props.updatePage !== nextProps.updatePage) {
  //         this.props.raceActions.getRaces();
  //         this.setState({
  //             updatePage: ""
  //         });
  //         this.props.raceActions.ResetUpdate();
  //     }
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.updatePage !== this.state.updatePage) {
  //     this.props.commonActions.ResetUpdate();
  //     this.props.raceActions.getRaces();
  //     this.setState({ updatePage: "" });
  //   }
  // }

  render() {
    return <RacePresentational {...this.state} {...this.props} ExecuteUpdate={this.ExecuteUpdate} />
  }
}

const mapStateToProps = (completeStore) => {
  return {
    race: completeStore.race,
    updatePage: completeStore.updatePage,
    live: completeStore.live,
  };
};


const mapDispatchToProps = (dispatch) =>
  ({
    raceActions: bindActionCreators(raceActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    liveActions: bindActionCreators(liveActions, dispatch),
  });

export default connect(mapStateToProps, mapDispatchToProps)(Race);